import {RouteInfo} from './sidebar.metadata';

export const ROUTES: RouteInfo[] = [
  {
    path: '/dashboard/dashboard3',
    title: 'Admin Dashboard',
    icon: 'icon-Car-Wheel',
    class: '',
    extralink: false,
    expectedRole: ['ADMIN'],
    submenu: []

  },
  {
    path: '/dashboard/dashboard1',
    title: 'User Dashboard',
    icon: 'icon-Car-Wheel',
    class: '',
    extralink: false,
    expectedRole: ['USER'],
    submenu: []

  },
  {
    path: '/dashboard/dashboard2',
    title: 'Personnel Dashboard',
    icon: 'icon-Car-Wheel',
    class: '',
    extralink: false,
    expectedRole: ['PERSONNEL'],
    submenu: []

  },
  {
    path: '',
    title: ' Configuration Management',
    icon: 'mdi mdi-dots-horizontal',
    class: 'nav-small-cap',
    extralink: true,
    expectedRole: ['ADMIN', 'OPERATOR'],
    submenu: []
  },
  {
    path: '/apps/cloudconfig',
    title: 'UBI Cloud',
    icon: 'icon-Cloud',
    class: '',
    extralink: false,
    expectedRole: ['ADMIN', 'OPERATOR'],
    submenu: []
  },
  {
    path: '',
    title: ' Concrete Batch Management',
    icon: 'mdi mdi-dots-horizontal',
    class: 'nav-small-cap',
    extralink: true,
    expectedRole: ['ADMIN', 'OPERATOR'],
    submenu: []
  },
  {
    path: '/apps/concretebatch',
    title: 'Concrete Batches',
    icon: 'fas fa-cog',
    class: '',
    extralink: false,
    expectedRole: ['ADMIN', 'OPERATOR'],
    submenu: []
  },
  {
    path: '/apps/createconcretebatch',
    title: 'Create Concrete Batch',
    icon: 'fas fa-plus',
    class: '',
    extralink: false,
    expectedRole: ['ADMIN', 'OPERATOR'],
    submenu: []
  },
  {
    path: '',
    title: 'Server Management',
    icon: 'mdi mdi-dots-horizontal',
    class: 'nav-small-cap',
    extralink: true,
    expectedRole: ['ADMIN', 'OPERATOR'],
    submenu: []
  },
  {
    path: '/apps/logmanager',
    title: 'Logging Levels',
    icon: 'fas fa-list-alt',
    class: '',
    extralink: false,
    expectedRole: ['ADMIN', 'OPERATOR'],
    submenu: []
  },{
    path: '/apps/threadstatus',
    title: 'Threads Status',
    icon: 'sl-icon-equalizer',
    class: '',
    extralink: false,
    expectedRole: ['ADMIN', 'OPERATOR'],
    submenu: []
  },
  {
    path: '',
    title: ' Equipment Management',
    icon: 'mdi mdi-dots-horizontal',
    class: 'nav-small-cap',
    extralink: true,
    expectedRole: ['ADMIN', 'USER'],
    submenu: []
  },
  {
    path: '/apps/mold',
    title: 'Molds',
    icon: 'icon-Mailbox-Empty',
    class: '',
    extralink: false,
    expectedRole: ['ADMIN', 'USER'],
    submenu: []
  },
  {
    path: '',
    title: 'Concreting',
    icon: 'icon-Ticket',
    class: 'has-arrow',
    extralink: false,
    expectedRole: ['ADMIN', 'USER'],
    submenu: [
      {
        path: '/apps/concreting',
        title: 'Concreting Batch',
        icon: '',
        class: '',
        extralink: false,
        expectedRole: ['ADMIN', 'USER'],
        submenu: []
      },
      {
        path: '/apps/tunnel-segment',
        title: 'Tunnel Segment',
        icon: '',
        class: '',
        extralink: false,
        expectedRole: ['ADMIN', 'USER'],
        submenu: []
      }
    ]
  },
  {
    path: '',
    title: 'User Management',
    icon: 'mdi mdi-dots-horizontal',
    class: 'nav-small-cap',
    extralink: true,
    expectedRole: ['ADMIN', 'PERSONNEL'],
    submenu: []
  },
  {
    path: '/apps/user',
    title: 'User Authorities',
    icon: 'icon-Paint-Brush',
    class: '',
    extralink: false,
    expectedRole: ['ADMIN', 'PERSONNEL'],
    submenu: []
  },
  {
    path: 'apps/user-info',
    title: 'User Information',
    icon: 'icon-Folder-Add',
    class: '',
    extralink: false,
    expectedRole: ['ADMIN', 'PERSONNEL'],
    submenu: []
  }
];
